import React, {useState, useRef, useEffect} from "react";
import './KYCNoItem.scss'
import { DocumentNew, getKYCData } from "../../../../util/API/KYC";
import { editUserDetails } from "../../../../util/API/customers";

function KYCNoItem({selectedUser, docType, setKycData, docname, groupid}) {
    const [selectedBase64Image, setSelectedBase64Image] = useState(null);
    const [doctype, setDoctype] = useState(docname === 'address' ? "address" : docname === 'selfie' ? "selfie" : "");
    const [idNum, setIdNum] = useState("");
    const [newDocType, setNewDocType] = useState("");
    const fileInputRef = useRef(null);

    const uploadPhoto = async() => {
        if (selectedBase64Image) {
            if (idNum) {
                await editUserDetails(selectedUser, `other5|${idNum}`);
            }
            await editUserDetails(selectedUser, `status|1`);
            const res = await DocumentNew(selectedUser, selectedBase64Image, newDocType, groupid, docname);
            console.log(res);
            const kycData = await getKYCData(selectedUser);
            setKycData(kycData);
        }
      }

    const handleFileSelect = async (event) => {
        const img = event.target.files[0];
        // setSelectedFile(img);
        if (img) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const base64 = e.target.result;
            setSelectedBase64Image(base64);
          }
          reader.readAsDataURL(img);
        }
      };

      const openFileSelectionDialog = () => {
        fileInputRef.current.click();
      };

    useEffect(() => {
        if (selectedBase64Image)
            uploadPhoto();
    }, [selectedBase64Image]);

    const handleIdChange = (event) => {
        setIdNum(event.target.value);
    }

    const handleDocumentTypeChange = (event) => {
        setNewDocType(event.target.value);
    };

    return (
        <div  className="kyc-item">
            <div className="kyc-input">
                    <p className="classification">Classification</p>
                    <div className="kyc-type">
                        <p className="docType">{docType}</p>
                    </div>
            </div>
            <input type="file" accept="image/*" onChange={handleFileSelect} style={{ display: "none" }} ref={fileInputRef} />
            <button className="upload-button" onClick={openFileSelectionDialog}>
                    Upload
            </button>
            {docType === 'Identification' && 
            <>
                <select 
                    value={newDocType}
                    onChange={handleDocumentTypeChange}
                    className="identification-kyc-select"
                >
                    <option value="">Select Document Type</option>
                    <option value="SA_ID">South African ID</option>
                    <option value="Passport">Passport</option>
                    <option value="Refugee_ID">Refugee Documentation</option>
                    <option value="Aslyum_permit">Asyulm Permit</option>
                </select>
                <input className="identification-kyc-id" type="text" placeholder="Document ID Number" onChange={handleIdChange}/>
            </>
            }
            
        </div>
    );
}

export default KYCNoItem;